import { isBefore, isSameDay, startOfDay, isSameMonth, isSameYear, isWithinInterval, eachDayOfInterval, startOfMonth, endOfMonth, } from "../../__compat__/date-fns/main.entry.mjs.mjs";
export function isRange(input) {
    return (Array.isArray(input) &&
        input.length === 2 &&
        input.every((item) => item === null || item instanceof Date));
}
export function isEmptySelection(selection) {
    return isRange(selection)
        ? selection[0] === null && selection[1] === null
        : selection === null;
}
export const isStart = ([start], date) => start !== null && isSameDay(date, start);
export const isEnd = ([, end], date) => end !== null && isSameDay(date, end);
export const shouldSelectStart = ([start, end], date) => start === null || // No start date is set
    (start !== null && end !== null) || // Both, start and end date are set
    (start && isBefore(date, startOfDay(start))); // A given date is before start date
export const shouldSelectEnd = ([start, end]) => start !== null && end === null;
export const isSameMonthAndYear = (dateOne, dateTwo) => {
    if (isEmptySelection(dateOne))
        return false;
    if (isRange(dateOne)) {
        if (dateOne[0]) {
            return isSameYear(dateOne[0], dateTwo) && isSameMonth(dateOne[0], dateTwo);
        }
        if (dateOne[1]) {
            return isSameYear(dateOne[1], dateTwo) && isSameMonth(dateOne[1], dateTwo);
        }
    }
    return (isSameYear(dateOne, dateTwo) &&
        isSameMonth(dateOne, dateTwo));
};
/* checks to see if there are any days of a given month within provided interval */
export const isMonthWithinInterval = (month, interval) => Boolean(eachDayOfInterval({
    start: startOfMonth(month),
    end: endOfMonth(month),
}).some((day) => isWithinInterval(day, interval)));
export const resolveDateInRange = (date, interval) => {
    const currentDate = new Date();
    if (date !== null && isWithinInterval(date, interval)) {
        return date;
    }
    if (isWithinInterval(currentDate, interval)) {
        return currentDate;
    }
    return interval.start;
};
//# sourceMappingURL=dateHelpers.mjs.mjs.map